// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__UWDDx","Nav":"Footer_Nav__3Crv3","LinkWrapper":"Footer_LinkWrapper__C3D3u","LinkText":"Footer_LinkText__YvGNP","Active":"Footer_Active__23a5x"};